export const EventEmitterTypes = {
    REFRESH_YEARLY_SETTINGS: 'REFRESH_YEARLY_SETTINGS',
    REFRESH_LOADED_YEAR_PRICE_BRACKET: 'REFRESH_LOADED_YEAR_PRICE_BRACKET',
    REFRESH_LOADED_YEAR_SEASON_DATES: 'REFRESH_LOADED_YEAR_SEASON_DATES',
    REFRESH_LOADED_YEAR_MAX_DAILY: 'REFRESH_LOADED_YEAR_MAX_DAILY',
    REFRESH_LOADED_YEAR_AREA_SCHEDULES: 'REFRESH_LOADED_YEAR_AREA_SCHEDULES',
    REFRESH_LOADED_YEAR_BLACKOUT: 'REFRESH_LOADED_YEAR_BLACKOUT',
    REFRESH_LOADED_YEAR_ADJUSTMENTS: 'REFRESH_LOADED_YEAR_ADJUSTMENTS',
    REFRESH_USERS: 'refreshUsers',
    REFRESH_INFO: 'refreshInfo',
    CUSTOMER_SAVE: 'customerSave',
    CUSTOMER_SEARCH: 'customerSearch',
    CUSTOMER_ADD: 'customerAdd',
    CUSTOMER_ADD_ANOTHER: 'customerAddAnother',
    TOGGLE_SIDEBAR: 'toggleSidebar',
    CLOSE_SIDEBAR: 'closeSidebar',
    OPEN_SIDEBAR: 'openSidebar',
    GET_IS_SIDEBAR_OPEN: 'isSidebarOpen',
    SET_SITE_LOADING: 'siteIsLoading',
    SET_SITE_LOADED: 'siteIsLoaded',
}